class Configuration {
    static getJSForceAccessTokenName(): string {
        const jsForceAccessTokenName = localStorage.getItem('jsForceAccessTokenName');
        return jsForceAccessTokenName ? jsForceAccessTokenName : '';
    }

    static getAccessToken(): string {
        const tokenName: string = Configuration.getJSForceAccessTokenName();
        let token = localStorage.getItem(tokenName);
        return token ? token : '';
    }

    static removeAccessToken(): void {
        const tokenName: string = Configuration.getJSForceAccessTokenName();
        localStorage.removeItem(tokenName);
    }

    static getRedirectURI(): string {
        const redirectUri = localStorage.getItem('redirectUri');
        return redirectUri ? redirectUri : '';
    }

    static getUseTokenWhenFetchingVehicleData(): boolean {
        const useAuthorizationTokenWhenFetchingVehicleData = localStorage.getItem('useAuthorizationTokenWhenFetchingVehicleData');
        const val:boolean = "false" !== useAuthorizationTokenWhenFetchingVehicleData;
        return val;
    }

    static getBaseURL() {
        const baseUrl = localStorage.getItem('baseUrl');
        return baseUrl;
    };

    static getMakeCollectionURL() {
        return Configuration.getBaseURL() + "/makes";
    }
    
    static getModelCollectionURL() {
        return Configuration.getBaseURL() + "/makes/:makeId/models";
    }

    static getYearCollectionURL() {
        return Configuration.getBaseURL() + "/years";
    }

    static getYearMakeCollectionURL() {
        return Configuration.getYearCollectionURL() + "?make={makeId}";
    }

    static getYearModelCollectionURL() {
        return Configuration.getYearMakeCollectionURL() + "&model={modelId}";
    }

    static getFloorplanCollectionURL() {
        return Configuration.getBaseURL() + "/floorPlans";
    }

    static getFloorplanMakeCollectionURL() {
        return Configuration.getFloorplanCollectionURL() + "?make={makeId}";
    }

    static getFloorplanModelCollectionURL() {
        return Configuration.getFloorplanMakeCollectionURL() + "&model={model}";
    }

    static getFloorplanYearCollectionURL() {
        return Configuration.getFloorplanModelCollectionURL() + "&year={year}";
    }

    static getCloudMessagingURL() {
        const cloudMessagingUrl = localStorage.getItem('cloudMessagingUrl');
        return cloudMessagingUrl;
    }

    static getCloudMessagingCampaignSearchURL() {
        return Configuration.getCloudMessagingURL() + '/CampaignSearch';
    }

    static getCloudMessagingStatisticsURL() {
        return Configuration.getCloudMessagingURL() + '/Campaign/{campaignId}/CampaignStatistics';
    }

    static getCloudCoreURL() {
        const cloudCoreURL = localStorage.getItem('cloudCoreUrl');
        return cloudCoreURL;
    }

    static getCloudGeoForwardURL() {
        return Configuration.getCloudCoreURL() +  '/sfauth/geoforward';
    }
}
  export default Configuration;
